enum StatusIcon {
    Done = 'icon-circle-check-outline-24',
    Fail = 'icon-error-outline-24',
    InProgress = 'icon-arrow-clockwise-time-24',
    Cancelled = 'icon-warning-24',
    Initiated = 'icon-arrow-clockwise-24',
}

export default StatusIcon;
